import { useEffect, useState } from 'react';

import { Box, Button, Stack } from '@mui/material';
import { IconPlus } from '@tabler/icons-react';
import CreditCardItem from '@features/settings-billing/components/CreditCardItem';
import { PaymentMethod } from '@app/types/payment';
import { updateDefaultMethod } from '@api/user/apiService';
import useToast from '@hooks/useToast';
import Loader from '@components/Loader/ui/Loader';

interface BillingPaymentMethodsProps {
  onAddPaymentMethod: () => void;
  paymentMethods: PaymentMethod[];
  refreshPaymentMethods: () => void;
  isPaymentMethodsLoading: boolean;
}

function BillingPaymentMethods(props: BillingPaymentMethodsProps) {
  const {
    onAddPaymentMethod,
    paymentMethods,
    refreshPaymentMethods,
    isPaymentMethodsLoading,
  } = props;
  const { showSuccess } = useToast();
  const [activeCardId, setActiveCardId] = useState('');

  const onCardClick = (id: string) => {
    if (activeCardId === id) {
      return;
    }
    setActiveCardId(id);
    updateDefaultMethod(id, () => {
      showSuccess('Success', 'Default payment method set');
    });
  };

  useEffect(() => {
    const activeCard = paymentMethods.find((card) => card.is_active);
    if (!activeCard) return;

    setActiveCardId(activeCard.id);
  }, [paymentMethods]);

  if (isPaymentMethodsLoading) return <Loader />;

  return (
    <Stack spacing={1} flexGrow={1} width="100%">
      {paymentMethods.map((card) => (
        <CreditCardItem
          key={card.id}
          card={card}
          onClick={() => onCardClick(card.id)}
          onDelete={() => {
            refreshPaymentMethods();
          }}
          isDefault={activeCardId === card.id}
        />
      ))}

      <Box>
        <Button
          size="small"
          color="primary"
          startIcon={<IconPlus size={16} />}
          sx={{
            minHeight: 0,
          }}
          onClick={onAddPaymentMethod}
        >
          Add payment method
        </Button>
      </Box>
    </Stack>
  );
}

export default BillingPaymentMethods;
